import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import OrderList from "../components/lists/OrderList";
import OrderHistoryList from "../components/lists/OrderHistoryList";
import { MdDeliveryDining, MdOutlineHistory } from "react-icons/md";

import "./style.css";
import { test_ip } from "../services/constants";
import { setError } from "../services/actions";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";

function Order() {
  const [activeOrders, setActiveOrders] = useState([]);
  const [orderHistory, serOrderHistory] = useState([]);
  const [currentPage, setCurrentPage] = useState("active");
  const diapach = useDispatch();

  useEffect(() => {
    var user = JSON.parse(localStorage.getItem("user"));
    var data = {
      user_id: user.user_id,
      server_token: user.server_token,
    };

    var data2 = {
      user_id: user.user_id,
      server_token: user.server_token,
      end_date: "",
      start_date: "",
    };
    Active_Order(data);
    Order_history(data2);
  }, []);

  const Active_Order = function (data) {
    // active orders page in orders tab
    var body = data;
    body = JSON.stringify(body);
    axios
      .post(`${test_ip}api/user/get_orders`, body, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        if (res.status === 200) {
          console.log(res.data);
          if (res.data.success == true) {
            var order_list = res.data.order_list; // you would get more active orders list
            const result = Object.keys(order_list).map(
              (key) => order_list[key]
            );
            console.log(res.data.order_list);
            setActiveOrders(result);
          } else {
            console.log(res.data.error_code);
            if (res.data.error_code == 999) {
              toast.error("Please Login !", {
                position: toast.POSITION.TOP_RIGHT,
              });
              localStorage.clear();
              window.location.reload();
            } else {
              diapach(
                setError({
                  error: true,
                  message: `failed, please check again(${res.data.error_code})`,
                })
              );
            }
          }
        } else {
          // do something
          console.log("erororor", res.data.error_code);
          if (res.data.error_code == 999) {
            console.log(true);
            toast.error("Please Login !", {
              position: toast.POSITION.TOP_RIGHT,
            });
            localStorage.clear();
            window.location.reload();
            console.log("sdfgh");
          } else {
            diapach(
              setError({
                error: true,
                message: `failed, please check again(${res.data.error_code})`,
              })
            );
          }
        }
      })
      .catch((err) => {
        // do something
        console.log(err);
        diapach(setError({ error: true, message: "failed,please reload" }));
      });
  };

  const Order_history = function (data) {
    // order history page in orders Tab
    var body = data;
    body = JSON.stringify(body);
    axios
      .post(`${test_ip}api/user/order_history`, body, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        if (res.status === 200) {
          console.log(res.data);
          if (res.data.success == true) {
            // order_list = res.data.order_list // you would get more active orders list
            serOrderHistory(res.data.order_list);
          } else {
            console.log(res.data.error_code);
          }
        } else {
          // do something
        }
      })
      .catch((err) => {
        // do something
      });
  };

  const handlePage = (page) => {
    setCurrentPage(page);
  };

  return (
    <div className="a-order-page">
      <div className="a-buttons">
        <button
          className={currentPage === "active" ? "btn-active" : ""}
          onClick={() => {
            handlePage("active");
          }}
        >
          <MdDeliveryDining size={25} color="var(--primary-color)" />
          <br />
          Active Order
        </button>
        <button
          className={currentPage === "order" ? "btn-active" : ""}
          onClick={() => {
            handlePage("order");
          }}
        >
          <MdOutlineHistory size={25} color="var(--primary-color)" />
          <br />
          Order History
        </button>
      </div>
      <div className={currentPage === "active" ? "page page-active" : "page"}>
        {activeOrders.map((ac) => {
          return <OrderList key={ac._id} value={ac} />;
        })}
      </div>
      <div className={currentPage === "order" ? "page page-active" : "page"}>
        {orderHistory.map((oc) => {
          return <OrderHistoryList key={oc._id} value={oc} />;
        })}
      </div>
    </div>
  );
}

export default Order;
